<template>
  <div
    class="container theme-configuration"
    ref="container"
  >
    <el-scrollbar wrap-class="m-scroll-wrap">
      <el-form
        label-position="top"
        content-width="480px"
        style="width:480px;margin:40px auto;"
        :model="this"
        :rules="rules"
        ref="form"
      >

        <el-form-item
          prop="systemName"
          :label="$t('management.theme.systemName_label')"
        >
          <el-input
            v-model="systemName"
            @keyup.native="systemName"
            :placeholder="$t('management.theme.systemName_placeholder')"
          ></el-input>
          <div class="remark">
            {{ $t("management.theme.systemName_remark") }}
          </div>
        </el-form-item>
        <el-form-item
          prop="systemSubtitle"
          :label="$t('management.login.system_subname_label')"
        >
          <el-input
            v-model="systemSubtitle"
            @keyup.native="systemSubtitle"
            :placeholder="$t('management.login.system_subname_placeholder')"
          ></el-input>
          <div class="remark">
            {{ $t("management.theme.systemName_remark") }}
          </div>
        </el-form-item>
        <el-form-item :label="$t('management.theme.systemLogo_label')">
          <icon-upload
            type="systemLogo"
            v-model="systemLogoInfo.fileId"
            :selected="selectedIcon"
            class="u-icon-upload"
            :listLength="4"
            @change="onIconChange"
          ></icon-upload>
          <div class="remark">{{ $t("management.theme.logo_remark") }}</div>
        </el-form-item>
        <el-form-item :label="$t('management.theme.favicon')">
          <div class="content">
            <favicon-upload
              type="browserIcon"
              v-model="favicon"
            ></favicon-upload>
            <div class="remark">
              {{ $t("management.theme.favicon_tip") }}
            </div>
          </div>
        </el-form-item>
        <el-form-item
          :label="$t('management.theme.version_info')"
          prop="systemVersion"
        >
          <el-input v-model="systemVersion"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.theme.compony_web')"
          prop="componyWeb"
        >
          <el-input v-model="componyWeb"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.theme.service_tel')"
          prop="serviceTel"
        >
          <el-input v-model="serviceTel"></el-input>
        </el-form-item>
        <el-form-item
          :label="$t('management.theme.copyright')"
          prop="copyRight"
        >
          <el-input v-model="copyRight"></el-input>
        </el-form-item>
        <el-form-item :label="$t('management.theme.about_logo')">
          <div class="m-about-icon">
            <bg-upload
              :disableDel="false"
              type="themeAboutIcon"
              v-model="aboutLogoInfo"
            ></bg-upload>
          </div>
          <div class="remark">
            {{$t('management.theme.remark')}}
          </div>
        </el-form-item>
        <el-form-item style="margin-top: 40px">
          <el-button
            type="primary"
            @click="onSet"
          >{{
            $t("common.setBtn_text")
            }}</el-button>
          <el-button @click="onPreview">{{
            $t("common.previewBtn_text")
            }}</el-button>
          <!-- <el-button @click="onReset">{{$t('common.cancelBtn_text')}}</el-button> -->
        </el-form-item>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
import { ErrorHandleMixin, LoadingMixin } from 'utils/mixin'
import iconUpload from 'components/icon-upload/icon-upload'
import faviconUpload from './favicon-upload'
import bgUpload from 'components/bg-upload/bg-upload'
import { telRule, charRule, allSpaceRule, max32ChartRule, max64ChartRule, requireRule, noChinese, URLRegExp, max128ChartRule, max255ChartRule } from 'utils/validator'
import Api from 'api/api'
import ApiConfig from 'api/config'
export default {
  name: 'theme-configuration',
  data () {
    return {
      systemName: '',
      systemSubtitle: '',
      fontImgInfo: {
        fileId: -1,
        path: ''
      },
      systemLogoInfo: {
        fileId: -1,
        path: ''
      },
      aboutLogoInfo: {
        fileId: -1,
        path: ''
      },
      themeSchema: '',
      themeColor: '',
      fontType: '1',
      selectedIcon: -1,
      systemVersion: '',
      copyRight: '',
      componyWeb: '',
      serviceTel: '',
      rules: {
        systemName: [requireRule, charRule, allSpaceRule, max64ChartRule, {
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (this.fontType === '1' && this.systemName === '') {
              callback(new Error(this.$t('common.require_valid_error')))
            }
            callback()
          }
        }],
        systemSubtitle: [requireRule, charRule, allSpaceRule, max64ChartRule, {
          trigger: 'blur',
          validator: (rule, value, callback) => {
            if (this.fontType === '1' && this.systemSubtitle === '') {
              callback(new Error(this.$t('common.require_valid_error')))
            }
            callback()
          }
        }],
        copyRight: [{ required: true, message: this.$t('management.theme.copyright_placeholder'), trigger: 'blur' }, charRule, max128ChartRule, allSpaceRule],
        systemVersion: [{ required: true, message: this.$t('management.theme.version_info_placeholder'), trigger: 'blur' }, charRule, max32ChartRule, allSpaceRule],
        componyWeb: [{ required: true, message: this.$t('management.theme.compony_web'), trigger: 'blur' }, allSpaceRule, max255ChartRule, URLRegExp],
        serviceTel: [{ required: true, message: this.$t('management.theme.service_tel_placeholder'), trigger: 'blur' }, telRule, charRule, max32ChartRule, noChinese, allSpaceRule]
      },
      nowIcon: null,
      colorlist: [],
      favicon: {
        fileId: -1,
        path: ''
      }
    }
  },
  computed: {
    fontImgBg () {
      if (this.themeColor === '') {
        return {}
      } else {
        return {
          'background-image': 'none',
          'background-color': this.themeColor
        }
      }
    }
  },
  watch: {
    themeSchema (value) {
      this.themeColor = this.colorlist.map(item => {
        if (item.code === this.themeSchema) {
          return item.color
        }
      })
    }
  },
  methods: {
    _getInfo () {
      let _loadingInstance = this._getLoading()
      Api.theme.query().then(res => {
        _loadingInstance.close()
        this.systemName = res.data.systemName
        this.systemSubtitle = res.data.systemSubtitle
        this.fontImgInfo = res.data.fontImgInfo
        this.systemLogoInfo = res.data.systemLogoInfo
        this.aboutLogoInfo = res.data.aboutIconInfo
        this.themeSchema = res.data.themeSchema
        this.fontType = res.data.fontType
        this.selectedIcon = this.systemLogoInfo.fileId
        this.nowIcon = res.data.systemLogoInfo
        this.favicon = res.data.browserIconInfo || { fileId: -1, path: '' }
        this.systemVersion = res.data.systemVersion
        this.copyRight = res.data.copyRight
        this.componyWeb = res.data.companyUrl
        this.serviceTel = res.data.hotLineNumber
        let _param = {
          fontType: this.fontType,
          themeSchema: this.themeSchema,
          systemLogoInfo: this.nowIcon,
          fontImgInfo: this.fontImgInfo,
          systemName: this.systemName,
          systemSubtitle: this.systemSubtitle,
          favicon: this.favicon,
          systemVersion: this.systemVersion,
          copyRight: this.copyRight,
          componyWeb: this.componyWeb,
          serviceTel: this.serviceTel
        }
        this.$storage.set('theme-info', _param)
      }).catch(() => {
        _loadingInstance.close()
      })
    },
    _getList () {
      Api.theme.list().then(res => {
        this.colorlist = res.data.list || []
        this._getInfo()
      })
    },
    _setInfo (param) {
      let _loadingInstance = this._getLoading()
      Api.theme.set(param).then(res => {
        _loadingInstance.close()
        this.$storage.set('systemName', this.systemName)
        document.getElementById('wiportalTitle').innerText = this.systemName
        this.selectedIcon = this.systemLogoInfo.fileId
        this.$message.success(this.$t('management.theme.set_success'))
      }).catch(() => {
        _loadingInstance.close()
      })
    },
    onSet () {
      this.$refs.form.validate(valid => {
        if (valid) {
          let _param = {
            fontType: this.fontType,
            themeSchema: this.themeSchema,
            systemLogo: this.systemLogoInfo.fileId,
            fontImg: this.fontImgInfo.fileId,
            systemName: this.systemName,
            systemSubtitle: this.systemSubtitle,
            browserIcon: this.favicon.fileId,
            systemVersion: this.systemVersion,
            copyRight: this.copyRight,
            companyUrl: this.componyWeb,
            hotLineNumber: this.serviceTel,
            aboutIconId: this.aboutLogoInfo.fileId
          }
          this._setInfo(_param)
        }
      })
    },
    onPreview () {
      this.$refs.form.validate(valid => {
        if (valid) {
          let _param = {
            fontType: this.fontType,
            themeSchema: this.themeSchema,
            systemLogoInfo: this.nowIcon,
            fontImgInfo: this.fontImgInfo,
            systemName: this.systemName,
            systemSubtitle: this.systemSubtitle,
            systemVersion: this.systemVersion,
            copyRight: this.copyRight,
            companyUrl: this.componyWeb,
            hotLineNumber: this.serviceTel,
            aboutIconInfo: this.aboutLogoInfo
          }
          this.$storage.set('theme-info', _param)
          window.open(`${ApiConfig.context}/index?tpw=true`)
        }
      })
    },
    onReset () {
      this._getInfo()
    },
    onIconChange (icon) {
      this.nowIcon = icon
    }
  },
  mounted () {
    this._getList()
  },
  mixins: [ErrorHandleMixin, LoadingMixin],
  components: {
    iconUpload,
    bgUpload,
    faviconUpload
  }
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.theme-configuration.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  /deep/ .m-scroll-wrap {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
  }
  .remark {
    line-height: 1;
    margin-top: 8px;
    color: #999;
  }
  .m-about-icon {
    width: 64px;
    height: 64px;
    border-radius: 2px;
    overflow: hidden;
  }
  .content .tip {
    font-size: 10px;
    color: #999;
    line-height: 1;
    margin-top: 8px;
    width: 700px;
  }
}
</style>
